import React from "react";


type Props = {
  image?: string;
  backgroundImage: string;
  MobilebgImage: string;
  graphImage?: string;
  mobilepraphImage?: string;
  heading?: string;
  description?: string;
  subDescription?: string;
  children?: string;
  ButtonclassName?: string;
  HeaderClassName?: string;
  descriptionClass?: string;
  className?: string;
  mainclassName?: string;
  buttonGroup?: any; // can pass button components
};

const PlatformModulesBanner = ({
  image,
  backgroundImage,
  MobilebgImage,
  heading,
  description,
  subDescription,
  children,
  buttonGroup,
  ButtonclassName,
  HeaderClassName,
  descriptionClass,
  className,
  mainclassName,
  graphImage,
  mobilepraphImage,
}: Props) => {
  return (
    <>
    {/* mobile */}
    <div className="d-block  d-md-none">
      <div
        style={{
          backgroundImage: `url(${MobilebgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
        className={`whyyantraiheader pt-20 pb-20 ${mainclassName}`}
      >
        <div className={`container ${className}`}>
          <div className="row p-2">
            <div className="col-lg-7 col-md-12">
              <p
                className={`main-heading wp-100 w-100 font-family-condensed line-46 fonts-300 font-40 my-20 ${HeaderClassName}`}
              >
                {heading}
              </p>
              <p
                className={`sub-heading font-family-roboto fonts-400 wp-50 fonts-400 font-20 line-32 ${descriptionClass}`}
              >
                {description}
              </p>
              <p
                className={`font-family-roboto wp-100 fonts-400 font-20 ${descriptionClass}`}
              >
                {subDescription}
              </p>
              <div
                className={`buttongroup d-flex justify-content-start flex-gap-20 mt-24 wp-28 ${ButtonclassName}`}
              >
                {buttonGroup}
              </div>
            </div>
            <div className="col-lg-5 col-md-6 mt-20">
              <img
                className="w-100 h-100"
                src={mobilepraphImage}
                alt="graphs are here"
              />
            </div>
            {/* <div className="col-md-1"></div> */}
          </div>
        </div>
      </div>
      </div>
      {/* Website */}
    <div className="d-none d-md-block">
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
        className={`whyyantraiheader pt-90 pb-30 ${mainclassName}`}
      >
        <div className={`container ${className}`}>
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <p
                className={`main-heading wp-100 font-family-condensed line-46 fonts-300 font-40 my-20 ${HeaderClassName}`}
              >
                {heading}
              </p>
              <p
                className={`sub-heading font-family-roboto fonts-400 wp-90 fonts-400 font-20 line-32 ${descriptionClass}`}
              >
                {description}
              </p>
              <p
                className={`font-family-roboto wp-100 fonts-400 font-20 ${descriptionClass}`}
              >
                {subDescription}
              </p>
              <div
                className={`buttongroup d-flex justify-content-start flex-gap-20 mt-24 wp-28 ${ButtonclassName}`}
              >
                {buttonGroup}
              </div>
            </div>
            <div className="col-lg-5 col-md-6 mt-10">
              <img
                className="w-100 h-100"
                //style={{ height: "30" }}
                src={graphImage}
                alt="graphs are here"
              />
            </div>
            {/* <div className="col-md-1"></div> */}
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default PlatformModulesBanner;
